// extracted by mini-css-extract-plugin
export default {"page_name":"EditWebpage_page_name__J-a9X","panel":"EditWebpage_panel__33PgF","panel_body":"EditWebpage_panel_body__FB8Aw","radio":"EditWebpage_radio__-HYXY"};